import { NgModule } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { OverlayModule } from '@angular/cdk/overlay';

@NgModule({
  exports: [MatButtonModule, MatIconModule, OverlayModule, MatMenuModule],
  imports: [MatButtonModule, MatIconModule, OverlayModule, MatMenuModule]
})
export class MaterialModule {}
